import React, { useState, useEffect, useRef } from 'react';
import './component.scss'
import arrowDown from '../../images/arrowDown.svg';
import arrowRight from '../../images/arrow-right.svg'

const CustomDropdown = ({ options, selectedValue, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null); // Create a ref for the dropdown container

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleSelect = (value) => {
    onChange(value);
    setIsOpen(false); // Close the dropdown after selection
  };

  // Close the dropdown when clicking outside of it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false); // Close dropdown if clicked outside
      }
    };

    document.addEventListener('mousedown', handleClickOutside); // Listen for clicks
    return () => {
      document.removeEventListener('mousedown', handleClickOutside); // Cleanup
    };
  }, []);

  return (
    <div className="custom-dropdown" ref={dropdownRef}> {/* Attach ref here */}
      <div className="dropdown-header" onClick={toggleDropdown}>
        {options.find(option => option.value === selectedValue)?.label || 'Select an option'}
        <img className={`arrow ${isOpen ? 'open' : ''}`} src={arrowDown} alt="Arrow" />
      </div>
      <ul className={`dropdown-list ${isOpen ? 'open' : ''}`} style={{ pointerEvents: isOpen ? 'all' : 'none' }}>
        {options.map(option => (
          <li key={option.value} onClick={() => handleSelect(option.value)}>
            {option.label}
            <img  src={arrowRight}/>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CustomDropdown;
